/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Proofreading API
 * PR TIMES 校正 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /lint
 * @export
 * @interface ProofreadingLintResponse
 */
export interface ProofreadingLintResponse {
    /**
     * 
     * @type {number}
     * @memberof ProofreadingLintResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ProofreadingLintResponse
     */
    message: string;
    /**
     * 校正結果取得用のid
     * @type {string}
     * @memberof ProofreadingLintResponse
     */
    lintId: string;
}

export function ProofreadingLintResponseFromJSON(json: any): ProofreadingLintResponse {
    return ProofreadingLintResponseFromJSONTyped(json, false);
}

export function ProofreadingLintResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProofreadingLintResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'lintId': json['lint_id'],
    };
}

export function ProofreadingLintResponseToJSON(value?: ProofreadingLintResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'lint_id': value.lintId,
    };
}

